import React from 'react';
import VerificationChallenge from './Sms';
import NewPasswordChallenge from './NewPassword';
import ProfileStepChallenge from './ProfileStep';
import { observer } from 'mobx-react-lite';
import { useLoginService } from '../../services/loginService/index';

 function Challenges() {
  const {
    state: { challenge, profileStepOnComplete },
  } = useLoginService();

  if (challenge?.name === 'SMS_MFA') {
    return <VerificationChallenge />;
  }

  if (challenge?.name === 'NEW_PASSWORD_REQUIRED') {
    return <NewPasswordChallenge />;
  }

  if (profileStepOnComplete) {
    return <ProfileStepChallenge />;
  }

  return null;
}
export default observer(Challenges);
